import { render, staticRenderFns } from "./RoundsOfRewardsItems.vue?vue&type=template&id=2f079d66&scoped=true&"
import script from "./RoundsOfRewardsItems.vue?vue&type=script&lang=js&"
export * from "./RoundsOfRewardsItems.vue?vue&type=script&lang=js&"
import style0 from "./RoundsOfRewardsItems.vue?vue&type=style&index=0&id=2f079d66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f079d66",
  null
  
)

export default component.exports